import * as React from 'react';
import * as _ from 'lodash';
import { change, DataShape, Field, FormProps, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import * as onboardingForm from 'login-utils/onboardingForm';
import * as onboardingRoutingUtils from 'login-utils/onboardingRoutingUtils';
import FoundSVG from 'login-components/Common/svg/FoundSVG';
import LargeIconButtonGroup from 'login-components/Common/LargeIconButtonGroup/LargeIconButtonGroup';
import LookingSVG from 'login-components/Common/svg/LookingSVG';
import RefinanceSVG from 'login-components/Common/svg/RefinanceSVG';
import States from 'login-constants/states';
import ThinkingSVG from 'login-components/Common/svg/ThinkingSVG';
import { LargeIconButtonConfig } from 'login-components/Common/Buttons/LargeIconButton';

interface TimelineConfig extends LargeIconButtonConfig {
  value: onboardingForm.TimelineValue;
}

const timelineChooserConfigs: TimelineConfig[] = [
  {
    value: 'NOT_STARTED',
    iconComponent: ThinkingSVG,
    buttonId: 'it-chooseTimelineNotStarted',
    text: "I'm just thinking about buying",
  },
  {
    value: 'STILL_LOOKING',
    iconComponent: LookingSVG,
    buttonId: 'it-chooseTimelineStillLooking',
    text: "I'm actively looking for a home",
  },
  {
    value: 'NOT_IN_CONTRACT',
    iconComponent: FoundSVG,
    buttonId: 'it-chooseTimelineNotInContract',
    text: 'I think I found the home I want to buy',
  },
  {
    value: 'REFINANCE',
    iconComponent: RefinanceSVG,
    buttonId: 'it-chooseTimelineRefinance',
    text: 'I want to refinance my home',
  },
];

export type ChooseTimelineOwnProps = ReactRouter.RouteComponentProps<{}, {}>;

interface ChooseTimelineStateProps {
  selectedValue?: onboardingForm.TimelineValue;
}

interface ChooseTimelineDispatchProps {
  selectValue(value: onboardingForm.TimelineValue): void;
}

type ChooseTimelineProps = ChooseTimelineOwnProps & ChooseTimelineStateProps & ChooseTimelineDispatchProps;

class ChooseTimeline extends React.Component<
  ChooseTimelineProps & FormProps<DataShape, ChooseTimelineProps, ReduxState>
> {
  onSelect = value => {
    const { selectValue, location } = this.props;
    const search = location!.search || '';
    const route = onboardingRoutingUtils.isShortFormEligible(value) ? States.SHORT_FORM : States.MILESTONES;

    selectValue(value);

    hashHistory.push(`${route}${search}`);
  };

  render() {
    return (
      <Field
        name={onboardingForm.FIELDS._timeline}
        configs={timelineChooserConfigs}
        onSelect={this.onSelect}
        component={LargeIconButtonGroup}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedValue: onboardingForm.getTimelineValue(state),
});

const mapDispatchToProps = dispatch => ({
  selectValue: value => {
    const formValuesToSet = onboardingForm.translateTimelineValueToFormProps(value);
    _.forEach(formValuesToSet, (formValue, key) => dispatch(change(onboardingForm.FORM_NAME, key, formValue)));
  },
});

const withReduxForm = reduxForm<FormProps<DataShape, ChooseTimelineProps, ReduxState>, ChooseTimelineProps, ReduxState>(
  onboardingForm.FORM_CONFIG,
)(ChooseTimeline);

export default connect<ChooseTimelineStateProps, ChooseTimelineDispatchProps, ChooseTimelineOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(withReduxForm);
